import React, { useState } from 'react';
import "./PostTemplate.css"
import { Link } from 'react-router-dom';
import END_POINT from '../../END_POINT';

const PostTemplate = ({data,index,setPost,setPost1}) => {
  const [postId, setPostId] = useState("");
  const deletePost = async () => {
        console.log(postId);
    await fetch(`${END_POINT}/post/deletePost/${postId}`)
    .then(res=>res.json())
    .then(data=>{
      const newArr = data.filter((data1) => {
        if (data1.isChecked) return true
    })
    newArr.reverse()
      setPost1(newArr)
      setPost(newArr)
        
    })

  }
  return (
    
      <div key={index} className=''>
          <div className="postBox container d-md-flex d-sm-flex justify-content-between my-3">
              <div className="postTitle p-2">
              
              <h2 className='w-100'>
              <Link style={{textDecoration:'none',color:'inherit',"display":"flex"}} to={`/detailview/${data._id}`}>   {data.title}</Link>
              <button style={{"float":"right"}} data-toggle="modal" data-target="#exampleModaldel" onClick={()=>setPostId(data._id)} type="button" className="btn-close btn-close-white" aria-label="Close"></button>
              </h2>
              {/* <span style={{"width":"100px","height":"100px"}}>
              
              </span> */}
              
              
                  <p>Author: {data.author.first+" "+data.author.last}
                  
                  </p>
                {!data.isChecked && <p style={{"color":"tomato"}}>Status:  Private</p>}
                {data.isChecked && <p style={{"color":"green"}}>Status:  Public</p>}
                
                {/* {user && post.author && post.author._id===user._id &&<p style={{"color":"tomato"}}>Status:  Private</p>} */}
                  <p className='viewdescription' contentEditable='false' dangerouslySetInnerHTML={{ __html: data.description }}></p>
                 
               <Link to={`/detailview/${data._id}`}>  <button className='btn btn-dark'>Read More</button></Link>
                 
              </div>
              
              
                  <img  src="https://i.ibb.co/jJyfXM9/absolutvision-82-Tp-Eld0-e4-unsplash.jpg" alt="" />
              
 
          </div>
          {/* Post delete warning modal starts here */}



 <div className="modal fade" id="exampleModaldel" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered" role="document">
  
    <div className="modal-content" style={{"textAlign":"center"}} >
    
      {/* <div className="modal-header" > */}
        <div className="d-flex justify-content-center">
        <img src="https://img.icons8.com/ios/100/FF0000/cancel.png"/>
        
        </div>

      {/* </div> */}
      <div className="modal-body">
      <h3 >Are you sure?</h3>   
      <br />
      <p style={{"color":'gray'}}>Do you really want to delete these records? This process cannot be undone.</p>
      </div>
      
      <div className="modal-footer d-flex justify-content-center">
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button onClick={deletePost} type="button" data-dismiss="modal" className="btn btn-danger">Delete</button>
      </div>
    </div>
  </div>
</div>

      {/* Post delete warning modal ends here */}
      </div>
  )
};

export default PostTemplate;
